import { useLang } from "../../context/LangContext";

export const ReviewBlock = ({ form, onEdit }) => {
  const { t } = useLang();
  const addr = [form.city, form.district, form.street, form.building_no && `${t("building_no")} ${form.building_no}`, form.postal_code, form.short_address]
    .filter(Boolean).join("، ");
  return (
    <div data-testid="review-block" className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="font-display text-2xl">{t("step_review")}</h2>
        <button data-testid="review-edit-button" onClick={onEdit} className="link-u text-sm text-gold-deep">{t("edit")}</button>
      </div>
      <div className="grid gap-6 border-y border-sand py-6 sm:grid-cols-2">
        <div>
          <p className="mb-2 text-xs tracking-[0.1em] text-sand-dark">{t("step_info")}</p>
          <p data-testid="review-name">{form.name}</p>
          <p dir="ltr" className="text-sm text-ink/70 rtl:text-right">{form.phone}</p>
          {form.email && <p className="text-sm text-ink/70">{form.email}</p>}
        </div>
        <div>
          <p className="mb-2 text-xs tracking-[0.1em] text-sand-dark">{t("delivery_address")}</p>
          <p data-testid="review-address" className="text-sm leading-6">{addr}</p>
          {form.notes && <p className="mt-1 text-xs text-ink/60">{form.notes}</p>}
        </div>
      </div>
    </div>
  );
};
